import { AutogenModelMultistop, AutogenRowMultistop } from "./autogen/AutogenModelMultistop";

export class ModelMultistop extends AutogenModelMultistop<RowMultistop> {
    constructor() {
        super(RowMultistop);
    }
}

export class RowMultistop extends AutogenRowMultistop {
}